
(function () {
  var DEPOSIT_PRODUCT_ID = 8919738777769;
  var MAX_QTY = 1;
  var LIMIT_LABEL = 'Only one purchase per customer';
  var busy = false;
  var atLimit = false;

  function styleButton(b) {
    if (atLimit) {
      if (!b.dataset.opoApplied) {
        b.dataset.opoApplied = '1';
        b.dataset.opoLabel = b.innerHTML;
        b.textContent = LIMIT_LABEL;
      }
      b.disabled = true;
      b.style.filter = 'grayscale(1)';
      b.style.opacity = '0.55';
      b.style.cursor = 'not-allowed';
    } else if (b.dataset.opoApplied) {
      b.innerHTML = b.dataset.opoLabel;
      delete b.dataset.opoApplied;
      delete b.dataset.opoLabel;
      b.disabled = false;
      b.style.filter = '';
      b.style.opacity = '';
      b.style.cursor = '';
    }
  }

  function setButtons() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('button[type="submit"], button[name="add"]')
        .forEach(styleButton);
    });
  }

  function sync() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (i) { return i.product_id === DEPOSIT_PRODUCT_ID; });
        var total = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
        atLimit = total >= MAX_QTY;
        setButtons();
        if (total > MAX_QTY && !busy) {
          busy = true;
          fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lines[0].key, quantity: MAX_QTY }),
          }).then(function () { window.location.reload(); })
            .catch(function () { busy = false; });
        }
      }).catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url || arguments[0] || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(sync, 300); });
    }
    return p;
  };

  new MutationObserver(setButtons)
    .observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();